import { Controller } from "stimulus"
import OS from "../lib/os"

export default class LinuxController extends Controller {

  os = new OS()
  static get targets() {
    return ['linux']
  }
  initialize() {
    if(this.os.linux()) {
      this.linuxTargets.forEach((t) => t.style.display = '')
    }
  }
}
